<template>
  <div id="pright" >
     <div v-if="itemList.length === 0" style="width:100%;text-align:center"><img  src="../assets/loading.gif" style="height: 2em; margin-top: 1em;"></div>
    <transition-group name="list" tag="div" class="gad">
      <div class="item" v-for="(item, index) in itemList" :key="index">
        <router-link :to="'/ponuda/' + dob + '/' + item.artikli_id + '/' + item.podkat_url + '-' +  item.artikli_naziv.toLowerCase().replace(' ', '-')">
        <img :src="'/images/namjestaj/' + item.artikli_id + '/0.jpg'" :alt="item.podkat_naziv + ' ' + item.artikli_naziv">
        <div class="naziv">{{item.podkat_naziv}} {{item.artikli_naziv}}<!-- <span v-if="item.artikli_boje">{{item.artikli_boje}}</span>--></div>
        <div class="cijena nds" v-if="item.artikli_donjacijena.toString() === '0'">TRENUTNO NEDOSTUPNO</div>
        <div class="cijena klk" v-else  v-on:click.prevent="dodaj(index)">{{item.artikli_donjacijena.toString().split('').reverse().join('').match(/.{1,3}/g).join('.').split('').reverse().join('')}}€<div id="dodaj">+</div></div>
        <div class="aDiv" v-if="item.artikli_akcija==1">AKCIJA</div>
        </router-link>
      </div>
    </transition-group>
    <div id="spacer">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: 'Dobavljac',
  components: {
  },
  data () {
    return {
      itemList: [],
      tempList: [],
      intr: ''
    }
  },
  metaInfo () {
    return {
      title: this.sTitle + ' - VND namještaj',
      meta: [
        { name: 'description', content: 'Prvi online diskont namještaja u Crnoj Gori. Poručite namještaj jednostavno od kuće.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'vndnamjestaj' },
        { property: 'og:title', content: this.sTitle + ' - VND namještaj' },
        { property: 'og:image', content: 'https://vndnamjestaj.me/img/icons/og/vndnamjestaj.jpg' },
        { property: 'og:url', content: 'https://vndnamjestaj.me' + this.$route.path }
      ]
    }
  },
  props: {
    dob: String
  },
  created () {
    if (this.$store.getters.sLoc !== this.$route.path) {
      this.loadItems()
      this.$store.dispatch('saveLocation', this.$route.path)
    } else {
      this.itemList = this.sList
    }
  },
  methods: {
    async loadItems () {
      clearInterval(this.intr)
      this.itemList = []
      const response = await fetch('https://vndnamjestaj.me/kaoitemlist.php?dob=' + this.dob)
      const data = await response.json()

      this.tempList = data
      this.intr = setInterval(() => {
        this.itemList.push(this.tempList.shift())
        if (this.tempList.length === 0) {
          this.$store.dispatch('saveList', this.itemList)
          clearInterval(this.intr)
        }
      }, 150)
    },
    dodaj (id) {
      this.$store.dispatch('dodMoj', this.itemList[id])
    }
  },
  computed: {
    sList: function () {
      return this.$store.getters.sList
    },
    sTop: function () {
      return this.$store.getters.sSkrol
    },
    sTitle: function () {
      if (this.itemList.length > 0) return this.itemList[0].kategorija_naziv
      return 'Najpovoljnije!'
    }
  },
  watch: {
    $route (to, from) {
      if (this.$store.getters.sLoc !== this.$route.path) {
        this.loadItems()
        this.$store.dispatch('saveLocation', this.$route.path)
      } else {
        this.itemList = this.sList
      }
    }
  }
}
</script>
<style lang="scss" scoped>

#pright{
  display: flex;
  flex-wrap: wrap;
  top: -5.5vw;
  width: 65.5vw;
  right: 0px;
  justify-content: space-between;
}

@media only screen and (max-width: 600px) {
  #pright{
    width: 100vw;
    padding: 60px 0px 0px;
    overflow: hidden;
    overflow-y: auto;
  }
}

.item{
    width: 21vw;
    height: 13vw;
    background-color: #fff;
    position: relative;
    margin: 0.4vw 0.4vw;
    border-radius: 0.8vw;
    overflow: hidden;
    border: 1px solid #ecedee;
    /* display: flex; */
    justify-content: center;
    align-items: center;
    background-image: url('../assets/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 10%;
  img{
    position: relative;
    height: 100%;
    transition: height 0.2s, width 0.2s, left 0.2s, top 0.2s;
  }
  /*
  img:hover{
    height: 104%;
    width: 105%;
    left: -2%;
    top: -2.5%;
  }
  */
}

@media only screen and (max-width: 600px) {
  .item{
    width: 90vw;
    height: calc(90vw * 0.61);
    margin: 14px auto;
    border-radius: 12px;
  }
}

.list-enter-active, .list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
  transition: 0s;
}

.gad{
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  padding-bottom: 5vw;
  align-content: baseline;
  width: 100%;
}

#spacer{
  display: none;
}
@media only screen and (max-width: 600px) {
  .gad{
    display: block;
    text-align: center;
    width: 100vw;
    position: relative;
  }
  #spacer{
    display: block;
    height: 18vw;
    width: 300px;
  }
}

.cijena{
  position: absolute;
  z-index: 888;
  color: #000;
  background-color: #fd0;
  width: 5vw;
  height: 2.4vw;
  border-radius: 1.6vw 0px 0px 0px;
  bottom: -0.25vw;
  right: -0.1vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  font-size: 1.3vw;
  box-shadow: 0px 0px 0.6vw 0px RGBA(0, 0, 0, 0.3);
  transition: width 0.3s;
}

#dodaj{
  opacity: 0;
  position: absolute;
  background-color: #fff;
  border-radius: 30px;
  width: 1.4vw;
  height: 1.4vw;
  bottom: 1.2vw;
  left: -0.3vw;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0.05vw 0.05vw 0.2vw 0px RGBA(0,0,0,0.3);
  font-weight: 400;
  transition: opacity 0.3s;
  color: #c00;
  font-size: 1vw;
}
@media only screen and (min-width: 601px) {
  .cijena:hover{
    width: 6vw;
  }
  .cijena:hover #dodaj{
    opacity: 1;
  }
}

.aDiv{
  position: absolute;
  z-index: 888;
  color: #F00;
  width: 5vw;
  height: 2.3vw;
  top: -0.25vw;
  right: -0.1vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  font-size: 1vw;
  background-color: RGBA(254,254,254,0.9);
  border-radius: 0px 0px 0px 1.6vw;
}

.nds{
  font-size:0.6vw
}

@media only screen and (max-width: 600px) {
  .cijena{
    position: absolute;
    z-index: 888;
    color: #000;
    background-color: #fd0;
    width: 60px;
    height: 30px;
    border-radius: 14px 0px 0px 0px;
    bottom: -0.25vw;
    right: -0.1vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 900;
    font-size: 18px;
    box-shadow: 0px 0px 0.6vw 0px RGBA(0, 0, 0, 0.3);
  }
  .cijena:active{
    width: 70px;
  }

  #dodaj{
    opacity: 0;
    position: absolute;
    background-color: #fff;
    border-radius: 30px;
    width: 20px;
    height: 20px;
    bottom: 16px;
    left: -10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 1px 1px 3px RGBA(0, 0, 0, 0.3);
    font-weight: 400;
    transition: opacity 0.3s;
    color: #c00;
    font-size: 22px;
  }

  .cijena:active #dodaj{
    opacity: 1;
  }

  .aDiv{
    position: absolute;
    z-index: 888;
    color: #F00;
    width: 60px;
    height: 30px;
    top: -0.25vw;
    right: -0.1vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 900;
    font-size: 14px;
    background-color: RGBA(254,254,254,0.9);
    border-radius: 0px 0px 0px 10px;
  }

  .nds{
    font-size:9px
  }

}

</style>
